// extracted by mini-css-extract-plugin
export default {"sidePopup":"SidePopup_sidePopup__uoYj6","slider":"SidePopup_slider__KXdCk"};